"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimLabel = void 0;
const barcode_1 = require("client/components/barcode");
const icons_1 = require("client/components/icons");
const store_1 = require("client/modules/orders/store");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const react_1 = require("react");
const React = require("react");
require("./claim-label.less");
const midLevelTitle = ["APRN", "NP", "PA", "RN"];
let ClaimLabel = class ClaimLabel extends react_1.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const claim = store_1.ordersStore.claim.value;
        const inventory = claim && claim.inventory;
        const patient = claim && claim.order.patient;
        const provider = claim && claim.order.provider;
        const orderSite = claim && claim.order.site;
        const providerTitle = provider && provider.title;
        const pic = providerTitle && midLevelTitle.includes(providerTitle)
            ? orderSite && orderSite.picProvider
            : provider;
        return (React.createElement("div", { className: "claim-label" },
            React.createElement("div", { className: "claim-label__container" },
                React.createElement("table", null,
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__provider-title" },
                                React.createElement("span", null, provider &&
                                    `${provider.firstName} ${provider.lastName}, ${provider.title}`))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__provider-info" },
                                React.createElement("span", null, orderSite && `${orderSite.name}`),
                                React.createElement("span", null, orderSite && orderSite.address),
                                React.createElement("span", null, orderSite &&
                                    `${orderSite.city}, ${orderSite.state} ${orderSite.zip}`),
                                React.createElement("span", null,
                                    "Phone:",
                                    " ",
                                    (provider && `${provider.phone}`) ||
                                        (orderSite && orderSite.phone)),
                                React.createElement("span", null,
                                    "NPI: ",
                                    provider && provider.npiNumber,
                                    " \u00A0 \u00A0 DEA #:\u00A0",
                                    provider && `${provider.dea}`,
                                    " \u00A0 \u00A0 Lic #:\u00A0",
                                    provider && `${provider.state} ${provider.stateLicense}`))),
                        pic && (React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__supervising-provider-info center" },
                                React.createElement("span", null,
                                    React.createElement("b", null,
                                        "Supervising Provider:",
                                        " ",
                                        `${pic.lastName}, ${pic.firstName} ${pic.title}`.toUpperCase())),
                                React.createElement("span", { className: "normal" },
                                    "NPI: ",
                                    pic.npiNumber,
                                    " \u00A0 DEA #: ",
                                    pic.dea,
                                    " \u00A0 Lic #",
                                    " ",
                                    pic.stateLicense)))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__patient" },
                                React.createElement("table", null,
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", null,
                                                React.createElement("table", null,
                                                    React.createElement("tbody", null,
                                                        React.createElement("tr", null,
                                                            React.createElement("td", { className: "left" }, "Patient Name: "),
                                                            React.createElement("td", { className: "left name" }, patient &&
                                                                `${patient.lastName}, ${patient.firstName}`)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", { className: "left" }, "Address: "),
                                                            React.createElement("td", { className: "left address" },
                                                                patient && `${patient.address}`,
                                                                React.createElement("br", null),
                                                                patient &&
                                                                    `${patient.city} ${patient.state} ${patient.zip}`)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", { className: "left" }, "DOB: "),
                                                            React.createElement("td", { className: "left" },
                                                                patient && `${patient.birthDate}`,
                                                                " /",
                                                                " ",
                                                                patient &&
                                                                    `${patient.gender === "1" ? "Male" : "Female"}`)),
                                                        React.createElement("tr", null,
                                                            React.createElement("td", { className: "left" }, "Home: "),
                                                            React.createElement("td", { className: "left" }, patient && `${patient.phone}`))))),
                                            React.createElement("td", { className: "align-top" },
                                                "Written:",
                                                " ",
                                                claim && moment(claim.date).format("MMM DD, YYYY"))))))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("table", null,
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "rxicon" },
                                                React.createElement(icons_1.RxIcon, null)),
                                            React.createElement("td", null, inventory && inventory.barCode && (React.createElement("div", { className: "print-barcode" },
                                                React.createElement(barcode_1.UiBarcode, { background: "transparent", displayValue: true, height: 50, lineColor: "#26324e", value: inventory.barCode, margin: 0, width: 1 }))))))))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", null, inventory && inventory.name))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "center" },
                                React.createElement("span", null, inventory && inventory.description))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", null,
                                    "Sig: ",
                                    inventory && `${inventory.defaultSig}`))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", null,
                                    "Days Supply: ",
                                    inventory && `${inventory.daysSupply}`))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("br", null),
                                React.createElement("br", null))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__signature" },
                                React.createElement("table", null,
                                    React.createElement("tbody", null,
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "underline" },
                                                React.createElement("div", { className: "sig-pad" },
                                                    provider && (React.createElement("img", { src: provider.signature, onLoad: () => {
                                                            this.props.onImgLoad &&
                                                                this.props.onImgLoad();
                                                        } })),
                                                    React.createElement("div", { className: "title" }, provider && provider.title))),
                                            React.createElement("td", null)),
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "label" }, "Prescriber Agent"),
                                            React.createElement("td", null)),
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "underline right-border" }, "\u00A0\u00A0\u00A0"),
                                            React.createElement("td", { className: "underline left-border" }, "\u00A0\u00A0\u00A0")),
                                        React.createElement("tr", null,
                                            React.createElement("td", { className: "label" }, "Dispense as Written"),
                                            React.createElement("td", { className: "label" }, "Substitution Permissible")))))),
                        React.createElement("tr", null,
                            React.createElement("td", { className: "claim-label__icd10" },
                                "ICD10: ",
                                inventory && `${inventory.typeICD10s}`)),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("span", null))))))));
    }
};
ClaimLabel = __decorate([
    mobx_react_1.observer
], ClaimLabel);
exports.ClaimLabel = ClaimLabel;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/claim-label/claim-label.tsx
// module id = 3727
// module chunks = 0